import type { UUID } from '@protector/utils/types';
import { coreServicesApiClient } from '@protector/api-client';
import { workspaceResponseSchema } from './schemas.ts';

export function getWorkspaceInfo(id: UUID) {
  return coreServicesApiClient.request({
    config: {
      method: 'GET',
      url: `/v2/workspaces/${id}`
    },
    outputSchema: workspaceResponseSchema
  });
}
